import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import format from 'date-fns/format';
import classNames from '../../../../utils/classnameUtils';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { isPast, isWithinInterval } from 'date-fns';

function EPGProgramItem({
  content,
  programItemHeaderComponent,
  epgItemCollection,
  translationTexts,
  selectedProgramItem,
  currentTime,
  eventKey,
  handleOnSelectedProgramItem,
  percentageOfTime,
  firstSwiper,
  selectedEpgId,
  enableEpgDropdown,
  onClickContentSelected,
  dateFormat
}) {
  const [currentTimeState, setCurrentTimeState] = React.useState(false);

  React.useEffect(() => {
    if (content?.startTime && content?.endTime) {
      setCurrentTimeState(isWithinInterval(Date.now(), { start: new Date(content.startTime), end: new Date(content.endTime) }));
    }
  }, [currentTime, content]);


  const hasCatchUpBool = !!content && (epgItemCollection?.hasCatchUp && isPast(new Date(content?.endTime)));

  const isSameProgramItem = (selectedProgramItem?.externalId === content?.externalId && selectedProgramItem?.endTime === content?.endTime && selectedProgramItem?.startTime === content?.startTime && selectedEpgId === epgItemCollection?.epgId)

  return (
    <Accordion.Toggle
      className={classNames(
        'epgGridList_row_header_toggle',
        'epgGridList_row_header_toggle_noContent_' + !content,
        'epgGridList_row_header_toggle_currentTime_' + currentTimeState,
        !!content && 'epgGridList_row_header_toggle_selected_' + isSameProgramItem)}
      variant="link"
      style={{ width: percentageOfTime + '%', padding: 0 }}
      onClick={() =>{
          if( !!content && enableEpgDropdown){
            return   handleOnSelectedProgramItem(content, eventKey, isSameProgramItem)
          }
          else if(!enableEpgDropdown && (currentTimeState || hasCatchUpBool)){
            onClickContentSelected({ selectedProgramItemR: content, epgItemCollection: epgItemCollection })  
            handleOnSelectedProgramItem(content, eventKey, isSameProgramItem)
          }
          else return null
        }
      }

      onKeyUp={(evt) => {
        firstSwiper?.updateProgress();
        /*var e = event || evt; content// for trans-browser compatibility
        var charCode = e.which || e.keyCode;
        if (charCode == 9) {
          //firstSwiper?.setProgress(startLineTime)
          console.log('startLineTime: ', startLineTime)
        }*/
      }}
    >
      {programItemHeaderComponent === "COMPONENT_ONE" && (
        <FadeIn key={"FadeIn-" + content?.externalId} delay={0} transitionDuration={500} className='programItemHeaderComponentOne'>
          <ProgramItemHeaderComponentOne
            hasCatchUpBool={hasCatchUpBool}
            content={content}
            translationTexts={translationTexts}
            dateFormat={dateFormat}
          />
        </FadeIn>
      )}
      {programItemHeaderComponent === "COMPONENT_TWO" && (
        <FadeIn key={"FadeIn-" + content?.externalId} delay={0} transitionDuration={500} className='programItemHeaderComponentTwo' childClassName={'programItemHeaderComponentTwo_component'}>
          <ProgramItemHeaderComponentTwo
            hasCatchUpBool={hasCatchUpBool}
            content={content}
            translationTexts={translationTexts}
          />
        </FadeIn>
      )}
    </Accordion.Toggle>
  );
};

export default React.memo(EPGProgramItem);



const ProgramItemHeaderComponentOne = (({ hasCatchUpBool, content, translationTexts, dateFormat }) =>
  <React.Fragment>
    <div className='epgGridList_row_header_title'>
      {hasCatchUpBool && <i className="epgGridList_row_header_hasCatchUp bi bi-arrow-counterclockwise"></i>}
      {
        content?.title ?
          content?.title + ' : ' + (content?.startTime && format(Date.parse(content.startTime), dateFormat))
          :
          translationTexts?.not_available
      }
    </div>
    {content?.description && <div className='epgGridList_row_header_description'>
      {content?.description}
    </div>}

  </React.Fragment>
)

const ProgramItemHeaderComponentTwo = ({ content, translationTexts }) => {
  const { title, episodeTitle, season, episode, startTime, endTime } = content || {}

  const lineText = (season && episode && episodeTitle) ? " - " : ""
  const episodeTitleText = episodeTitle ? episodeTitle : "";
  const seasonAndEpisodeText = (season && episode) ? (`T${season} : E${episode}`) : ""
  const titleText = title || translationTexts?.not_available;

  return (
      <div className='programItemHeaderComponentTwo_container'>
        <div className='programItemHeaderComponentTwo_titleContainer'>
          {<div className='programItemHeaderComponentTwo_title'>
            {titleText}
          </div>}
          {(episodeTitleText || seasonAndEpisodeText) && <div className='programItemHeaderComponentTwo_subTitle'>
            {seasonAndEpisodeText + lineText + episodeTitleText}
          </div>}
        </div>
        {startTime && endTime && <div className='programItemHeaderComponentTwo_time'>
          {format(Date.parse(startTime), 'HH:mm') + ' - ' + (format(Date.parse(endTime), 'HH:mm'))}
        </div>}
      </div>
  );
}
